import { Injectable, inject } from "@angular/core";
import { ModalService } from "src/shared/modal";
import { CompanyLocationFormComponent } from "./company-location-form.component";

@Injectable()
export class CompanyLocationFormService {
  private readonly modal = inject(ModalService)


  showCompanyLocation() {
    return this.modal.openDialog<CompanyLocationFormComponent, void, string>(CompanyLocationFormComponent).toPromise()
  }
}
